import * as types from '../actions'

const initialState = {
    heroUnitScrolled: false,
    heroUnitScrolledMobile: false,
    navOpen: false,
    navHeight: 0,
    isIndustryFilterFocused: false,
    isLocationFilterFocused: false,
    scrollOffset: 0,
    isAboutOpen: false,
    activeVideoIdx: 0
}

const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.HERO_UNIT_SCROLLED:
            return Object.assign({}, state, {
                heroUnitScrolled: action.isScrolled
            })
        case types.HERO_UNIT_MOBILE_SCROLLED:
            return Object.assign({}, state, {
                heroUnitScrolledMobile: action.isScrolled
            })
        case types.NAV_OPEN:
            return Object.assign({}, state, {
                isNavOpen: action.isNavOpen
            })
        case types.SET_NAV_HEIGHT:
            return Object.assign({}, state, {
                navHeight: action.navHeight
            })
        case types.FOCUS_FILTER_INDUSTRY:
            return Object.assign({}, state, {
                isIndustryFilterFocused: action.isIndustryFilterFocused
            })
        case types.FOCUS_FILTER_LOCATION:
            return Object.assign({}, state, {
                isLocationFilterFocused: action.isLocationFilterFocused
            })
        case types.SET_FILTER_SCROLL_OFFSET:
            return Object.assign({}, state, {
                scrollOffset: action.scrollOffset
            })
        case types.OPEN_ABOUT_SECTION:
            return Object.assign({}, state, {
                isAboutOpen: action.isOpen
            })
        case types.ACTIVE_VIDEO_IDX:
            return Object.assign({}, state, {
                activeVideoIdx: action.activeVideoIdx
            })
        default:
            return state
    }
}

export default uiReducer


// WEBPACK FOOTER //
// ./src/reducers/ui.js